import myHealth from '@web/containers/MyHealth/localization'
import _ from 'lodash'

const localization = {
  en: {
    noData: 'No recorded'
  },
  es: {
    noData: 'Los resultados de'
  },
  keyMapping: {
    noData: 'UFD_No_Record_Text'
  }
}

export default _.merge(myHealth, localization)
